import React, { useState } from 'react'
import { EmptyAlbumIcon, LeftArrowIcon, RightArrowIcon, TIcon } from '../icons'

//redux
import { useSelector } from 'react-redux'
import { RootState } from '../store/rootReducer'
import { useHistory } from 'react-router'

interface TextsI {
	heading: string
	desc: string
	buttonText: string
}

export const TextAndButtonPost: React.FC = () => {
	const [texts, setTexts] = useState<TextsI>({
		heading: 'THE AD GRAPHICS YOU NEED AND CONVERT',
		desc: 'Create converting ad graphics in a few clicks with AdCreative.ai',
		buttonText: 'Button Text',
	})
	//global State
	const isPost = useSelector((state: RootState) => state.util.isPost)

	const onTextChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		// if (e.currentTarget.value.length >= 50) return
		setTexts({
			...texts,
			[e.currentTarget.name]: e.currentTarget.value,
		} as TextsI)
	}

	//history hook
	const { push } = useHistory()

	return (
		<div className='text-and-button-post'>
			<h5>ADYOUNEED Branding</h5>
			<h1>Texts and Button</h1>
			<p>
				Write an appealing headline & description for your creative and select
				your favorite font. The shorter and the more clear the texts, the
				better.
			</p>
			<section className='cards-grid'>
				<section className='post-size'>
					<section className='content'>
						<section className='left-area'>
							<TIcon />
							<h4>Post Size</h4>
						</section>
						<section className='right-area'>
							<small>
								<b>(1080x1080)</b>
							</small>
						</section>
					</section>
					<section className='inputs-area'>
						<textarea
							rows={3}
							name='heading'
							value={texts.heading}
							onChange={onTextChangeHandler}
						/>
						<textarea
							rows={3}
							name='desc'
							value={texts.desc}
							onChange={onTextChangeHandler}
						/>
						<textarea
							rows={2}
							name='buttonText'
							value={texts.buttonText}
							onChange={onTextChangeHandler}
						/>
					</section>
				</section>
				<section className='text-view'>
					<section
						className='all-main-content'
						style={{
							width: !isPost ? '223px' : '100%',
							margin: !isPost ? 'auto' : '',
						}}>
						<EmptyAlbumIcon />
						<>
							<h4>{texts.heading}</h4>
							<p>{texts.desc}</p>
						</>
						<section className='button-section'>
							<button>{texts.buttonText}</button>
						</section>
					</section>
				</section>
			</section>
			<section className='buttons-section'>
				<section className='back-button-section'>
					<button onClick={() => push('/creativeformpost')}>
						<LeftArrowIcon />
						Go Back
					</button>
				</section>
				<section className='continue-button-section'>
					<button>
						Save & Continue <RightArrowIcon />
					</button>
				</section>
			</section>
		</div>
	)
}
